// extracted by mini-css-extract-plugin
module.exports = {"nav-panel":"me","navPanel":"me","nav-panel-bg":"mf","navPanelBg":"mf","nav-panel-content":"mg","navPanelContent":"mg","none":"mh","block":"mi"};